
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SearchableDocumentsList from "@/components/documents/SearchableDocumentsList.vue";
  import DocumentItem from "@/components/documents/DocumentItem.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import ProjectsMultiselect from "@/components/autocompleteMultiselects/ProjectsMultiselectV2.vue";

  import { Document, Project, User } from "@/generated/graphql";
  import RouteParams from "@/entities/RouteParams";

  @Component({
    components: {
      SearchableDocumentsList,
      DocumentItem,
      CardBodyItem,
      ProjectsMultiselect,
    },
  })
  export default class ProjectsDocumentsFilteredList extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: String, default: undefined }) readonly companyId?: string;
    @Prop({ type: String, required: true  }) readonly projectDetailsRouteName!: string;

    filtersTouched: boolean = false;
    chosenProjectsIds: string[] = [];

    get query(): Object {
      if (this.chosenProjectsIds.length === 0) {
        return {
          company_id: {
            _eq: this.companyId,
          },
          document_projects: {
            project_id: {
              _is_null: false,
            },
          },
        };
      }

      return {
        company_id: {
          _eq: this.companyId,
        },
        document_projects: {
          project_id: {
            _in: this.chosenProjectsIds,
          },
        },
      };
    }

    onProjectSelected(projectIds: string[]): void {
      this.filtersTouched = true;
      this.chosenProjectsIds = projectIds;
    }

    getRouteParams(document: Document): RouteParams<{id: string}> {
      return {
        name: this.projectDetailsRouteName,
        params: {
          id: this.getProjectId(document),
        }
      };
    }

    isProjectExist(document: Document): boolean {
      return document.document_projects.length > 0;
    }

    getProject(document: Document): Project {
      return document.document_projects[0].project!;
    }

    getDocumentProjectName(document: Document): string {
      return this.getProject(document).name!;
    }

    getProjectId(document: Document): string {
      return this.getProject(document).id!;
    }
  }
